import { render, staticRenderFns } from "./PixInfractions.vue?vue&type=template&id=14a9cf5a&scoped=true"
import script from "./PixInfractions.vue?vue&type=script&lang=ts"
export * from "./PixInfractions.vue?vue&type=script&lang=ts"
import style0 from "./PixInfractions.vue?vue&type=style&index=0&id=14a9cf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9cf5a",
  null
  
)

export default component.exports